/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateBitcoinAddressRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {CreateBitcoinAddressResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const createBitcoinAddress = (request: CreateBitcoinAddressRequest, options?: CashRequestOptions) => post<CreateBitcoinAddressRequest, CreateBitcoinAddressResponse>("/2.0/cash/create-bitcoin-address", request, {...options, rejectOnError: true })